// import React, { useState, useRef, useEffect } from 'react';
import styles from './iframeBox.less?modules';

const IframeBox = (props) => {
  // const innerRef = useRef(null);
  // const baseSrc = 'http://localhost:9528/#';
  const baseSrc = 'http://100.101.102.143:9999/#';

  // const [iFrameHeight, setIFrameHeight] = useState('700px');

  // useEffect(() => {
  //   console.log(document.documentElement);
  //   document.documentElement.style.overflow = 'hidden';
  //   document.documentElement.style.height = '100%';
  //   document.body.style.overflow = 'hidden';
  //   document.body.style.height = '100%';
  //   // document.getElementById('root').style.height = '100%';
  //   // document.getElementById('root-div').style.height = '100%';
  //   // document.getElementsByClassName('App')[0].style.height = '100%';

  //   return () => {
  //     document.documentElement.style.overflow = 'auto';
  //     document.documentElement.style.height = 'auto';
  //     document.body.style.overflow = 'auto';
  //     document.body.style.height = 'auto';
  //     // document.getElementById('root').style.height = 'auto';
  //     // document.getElementById('root-div').style.height = 'auto';
  //     // document.getElementsByClassName('App')[0].style.height = 'auto';
  //   };
  // }, []);
  // console.log(baseSrc + props.src);
  return (
    <div className={styles.iframe_container}>
      <iframe
        id="iframeFaq"
        title="iframeFaq"
        // ref={innerRef}
        style={{ overflow: 'visible', border: 0, background: '#fff' }}
        // style={{ width: '100%', height: iFrameHeight, overflow: 'visible', border: 0 }}
        // style={{ width: '100%', height: '100%', overflow: 'visible' }}
        // onLoad={() => {
        //     // const obj = ReactDOM.findDOMNode(this);
        //     console.log(innerRef.current);
        //     console.table(innerRef.current.document);
        //     // setIFrameHeight(obj.contentWindow.document.body.scrollHeight + 'px');
        //     setIFrameHeight(innerRef.current.document.body.scrollHeight + 'px');
        // }}
        sandbox="allow-scripts allow-forms allow-same-origin"
        scrolling="auto"
        src={baseSrc + props.src}
        width="100%"
        height="100%"
        border="0"
      />
    </div>
  );
};

export default IframeBox;
